import { render, staticRenderFns } from "./TotalAmount.vue?vue&type=template&id=1b2fbbbd&scoped=true"
import script from "./TotalAmount.vue?vue&type=script&lang=js"
export * from "./TotalAmount.vue?vue&type=script&lang=js"
import style0 from "./TotalAmount.vue?vue&type=style&index=0&id=1b2fbbbd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2fbbbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b2fbbbd')) {
      api.createRecord('1b2fbbbd', component.options)
    } else {
      api.reload('1b2fbbbd', component.options)
    }
    module.hot.accept("./TotalAmount.vue?vue&type=template&id=1b2fbbbd&scoped=true", function () {
      api.rerender('1b2fbbbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/StoryMode/FinancialPlan/Components/TotalAmount.vue"
export default component.exports